import { Component } from '@angular/core';
import { CoreService } from 'src/app/shell/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  template: `
    <div class="branding">
      @if(options.theme === 'dark') {
      <a href="/home">
        <img
          src="./assets/images/logos/dark-explo.svg"
          class="align-middle m-2"
          alt="logo"
        />
      </a>
      } @if(options.theme === 'light') {
      <a href="/home">
        <img
          src="./assets/images/logos/explo.svg"
          class="align-middle m-2"
          alt="logo"
        />
      </a>
      }
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}
}
